import { gql } from 'graphql-tag';

export const GET_PAGE_OF_RESOURCE_PLAN_USER_TASKS = gql`
  query getPageOfResourcePlanAllocatedUserTasks(
    $pageSize: Int!
    $page: Int!
    $userId: String!
    $projectId: String!
    $includeTimeEnteredTasks: Boolean
  ) {
    project(projectId: $projectId) {
      id
      pageOfResourcePlanAllocatedUserTasks(
        page: $page
        pageSize: $pageSize
        userUri: $userId
        includeTimeEnteredTasks: $includeTimeEnteredTasks
      ) {
        task {
          id
          uri
          code
          displayText
        }
        projectRole {
          id
          displayText
        }
        fullPath {
          id
          uri
          slug
          displayText
        }
        estimateUri
        isUnassigned
        hasTimeEntered
      }
    }
  }
`;

export const getPageOfResourcePlanAllocatedUserTasks = async ({
  apolloClient,
  page,
  pageSize,
  userId,
  projectId,
  includeTimeEnteredTasks
}) => {
  const { loading, data } = await apolloClient.query({
    query: GET_PAGE_OF_RESOURCE_PLAN_USER_TASKS,
    variables: {
      pageSize,
      page,
      userId,
      projectId,
      includeTimeEnteredTasks
    },
    fetchPolicy: 'network-only'
  });

  return {
    resourcePlanAllocatedUserTasks:
      data?.project?.pageOfResourcePlanAllocatedUserTasks || [],
    loading
  };
};
